import { useIsMobile } from '@utils/hooks/useIsMobile'

import Button from '@components/Button/Button'
import Typography from '@components/Typography/Typography'

interface IStatusBarProps {
  status: 'warning' | 'error' | 'success' | 'info'
  text?: string | React.ReactNode
  actions?:
    | {
        text: string
        onClick: () => void
      }[]
    | null
}

const StatusBar: React.FC<IStatusBarProps> = ({ status, text, actions }) => {
  const { isMobile } = useIsMobile()
  return (
    <div
      className={`w-full p-3 gap-4 flex flex-col items-start justify-between sm:flex-row sm:items-center sm:p-4 sticky top-0 z-40 ${
        status === 'warning'
          ? 'bg-[#FBBF24]'
          : status === 'error'
            ? 'bg-[#F5B1AF]'
            : status === 'success'
              ? 'bg-green-400'
              : 'bg-blue-400'
      }`}>
      <Typography
        variant={isMobile ? 'body2' : 'body1'}
        color='textPrimary'
        className={`${
          status === 'warning'
            ? 'text-[#9F1815]'
            : status === 'error'
              ? 'text-[#9F1815]'
              : status === 'success'
                ? 'text-green-700'
                : 'text-blue-700'
        }`}
        dangerouslySetInnerHTML={{ __html: String(text) || '' }}
      />
      {actions &&
        actions.map((action, index) => (
          <Button
            key={index}
            onClick={action.onClick}
            variant='outlined'
            color='error'
            size={isMobile ? 'small' : 'medium'}
            className='text-nowrap text-gray-900'>
            {action.text}
          </Button>
        ))}
    </div>
  )
}

export default StatusBar
